var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutoArrowBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BACK",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_394",
    "data-name": "Ellipse 394",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 35.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14677",
    "data-name": "Path 14677",
    d: "M12.315,17.372a3.894,3.894,0,0,1,.662-.528l15.7-15.7A3.923,3.923,0,0,1,34.221,6.7L20.7,20.214,34.29,33.8a3.921,3.921,0,1,1-5.545,5.546L12.978,23.583a4.071,4.071,0,0,1-.662-6.211Z",
    transform: "translate(11.195 17.251)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutoArrowBtn);
export default __webpack_public_path__ + "static/media/tuto-arrow-btn.eb302f65.svg";
export { ForwardRef as ReactComponent };